<template>
<el-dialog class='change_password' title="修改密码" size="small" @close='close' :visible.sync="dialogVisible">
  <el-form ref="form" :rules="rules" :model="form">
    <el-form-item prop="oldPassword" :error="errors.first('oldPassword')">
      <el-input type='password' v-model='form.oldPassword' :placeholder="$t('placeholder.user.oldPassword')" />
    </el-form-item>

    <el-form-item prop="newPassword" :error="errors.first('newPassword')">
      <el-input type='password' name='password' v-model='form.newPassword' :placeholder="$t('placeholder.user.newPassword')" />
    </el-form-item>

    <el-form-item prop="passwordConfirmation" :error="errors.first('passwordConfirmation')">
      <el-input type='password' v-model='form.passwordConfirmation' :placeholder="$t('placeholder.user.passwordConfirmation')" />
    </el-form-item>
  </el-form>

  <div class='footer' slot='footer'>
    <el-button type='text' @click='close'>取消</el-button>
    <el-button type='primary' @click='save'>确定</el-button>
  </div>
</el-dialog>
</template>

<script>
import Validator from '@/mixins/validator'

export default {
  data() {
    return {
      form: {
        oldPassword: null,
        newPassword: null,
        passwordConfirmation: null
      },
      dialogVisible: false
    }
  },
  mixins: [Validator],
  rules: {
    confirmed: { target: 'passwordConfirmation', original: 'newPassword', recursion: 'form' },
    required: ['oldPassword', 'newPassword']
  },
  methods: {
    open() {
      this.dialogVisible = true
    },
    close() {
      this.$refs['form'].resetFields()
      this.dialogVisible = false
    },
    save() {
      let vm = this
      vm.$refs['form'].validate(res => {
        if (res) {
          // 验证通过
          vm.$store.dispatch('user/changePassword', {
            current_password: vm.form.oldPassword,
            password: vm.form.newPassword
          }).then(_ => {
            vm.$message({
              message: '修改密码成功',
              type: 'success'
            })
            vm.close()
          }).catch(err => {
            let data = err.response.data
            if (data.type === 'PasswordIncorrectError') {
              vm.errors.add('oldPassword', data.message)
            }
          })
        }
      })
    }
  }
}
</script>

<style lang='scss' scoped>
.change_password {
    .el-form {
        margin: 20px 0;
    }
}
</style>



// WEBPACK FOOTER //
// change_password.dialog.vue?a34f30ce